import { memo } from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';
import { OptionFillSkeleton } from '../../../features/question-card-ai/components/OptionFillSkeleton';
import { fillSlotAtom } from '../../../features/question-card-ai/stores/questionCardAi.atoms';
import { useFocusTarget } from '../../focus/useFocusTarget';
import { DeleteButton } from '../DeleteButton';
import { HeightAnimate } from '../HeightAnimate';
import { useQuizFormField } from '../hook/useQuizFormField';
import { useQuizControl } from '../QuizControlProvider';
import { AnswerInput } from './AnswerInput';
import { AnswerMarker } from './AnswerMarker';
import { useSubjectiveAnswerHotKey } from './useSubjectiveAnswerHotKey';
export const EditableSubjectiveAnswer = memo(({
  onFocus,
  onRemove,
  answerIndex,
  answerKey,
  isLastAnswer
}: {
  onFocus: () => void;
  onRemove?: () => void;
  answerIndex: number;
  answerKey: string;
  isLastAnswer: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    id: quizId,
    index
  } = useQuizControl();
  const answerRef = useFocusTarget<HTMLInputElement>(`quizList.${index}.subjectiveData.answerList.${answerIndex}.text`);
  const [answer, updateAnswer] = useQuizFormField({
    field: `subjectiveData.answerList.${answerIndex}.text`
  });
  const onKeyDown = useSubjectiveAnswerHotKey({
    isLastAnswer,
    answerIndex
  });

  // 비어 있는 칸은 0번(주요 정답)도 채움 대상이다.
  const fillSlot = useAtomValue(fillSlotAtom)[quizId];
  const showFillSkeleton = fillSlot?.status === 'running' && !!fillSlot.slotIds?.includes(answerKey) && !String(answer ?? '').trim();
  return <HeightAnimate>
        <div className="group w-full">
          <div className="flex w-full items-center gap-sm">
            <AnswerMarker />
            <div className="relative w-full">
              {showFillSkeleton && <OptionFillSkeleton />}
              <AnswerInput ref={answerRef} onKeyDown={onKeyDown} onFocus={e => {
            onFocus();
            e.stopPropagation();
          }} onClick={e => {
            e.stopPropagation();
            e.preventDefault();
          }} value={answer} onChange={e => updateAnswer(e.target.value)} placeholder={t('createSubjective.answer.placeholder')} />
            </div>
            {onRemove && <DeleteButton onClick={e => {
          onRemove?.();
          e.stopPropagation();
          e.preventDefault();
        }} onMouseDown={e => {
          e.preventDefault();
          e.stopPropagation();
        }} />}
          </div>
        </div>
      </HeightAnimate>;
});